export default __webpack_public_path__ + "static/media/SWT1420.34I-35413_-22663_0.76a8cec5.jpg";